__turbopack_context__.v({
  "bannerAction": "Coverage-module__loKCrG__bannerAction",
  "bannerContent": "Coverage-module__loKCrG__bannerContent",
  "bannerSubtitle": "Coverage-module__loKCrG__bannerSubtitle",
  "bannerTitle": "Coverage-module__loKCrG__bannerTitle",
  "cities": "Coverage-module__loKCrG__cities",
  "cityTag": "Coverage-module__loKCrG__cityTag",
  "coverage": "Coverage-module__loKCrG__coverage",
  "coverageBanner": "Coverage-module__loKCrG__coverageBanner",
  "grid": "Coverage-module__loKCrG__grid",
  "mapContainer": "Coverage-module__loKCrG__mapContainer",
  "mapFrame": "Coverage-module__loKCrG__mapFrame",
  "mapLoading": "Coverage-module__loKCrG__mapLoading",
  "mapWrapper": "Coverage-module__loKCrG__mapWrapper",
  "markerServices": "Coverage-module__loKCrG__markerServices",
  "regionCard": "Coverage-module__loKCrG__regionCard",
  "regionHeader": "Coverage-module__loKCrG__regionHeader",
  "regionIcon": "Coverage-module__loKCrG__regionIcon",
  "regionName": "Coverage-module__loKCrG__regionName",
  "regionSubtext": "Coverage-module__loKCrG__regionSubtext",
});
